/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";

export const muiPaginationStyle = (): Components<Theme>["MuiPagination"] => ({
  defaultProps: {
    getItemAriaLabel: (type, pageNumber, selected) => {
      switch (type) {
        case "first":
          return "Zur ersten Seite";
        case "previous":
          return "Zur vorherigen Seite";
        case "next":
          return "Zur nächsten Seite";
        case "last":
          return "Zur letzten Seite";
        case "page":
          return `Seite ${pageNumber}${selected ? ", aktuelle Seite" : ""}`;
        default:
          return "";
      }
    },
  },
});
